import { useFormik } from "formik";
import { useRef, useState, useEffect } from "react";
import * as Yup from "yup";
import * as Constants from "../../../constants/Constants";
import { GrubErrorHook } from "../../../hooks/index";
import { sendOTP } from "../services/authServices";
import GrubToastMessage from "../../../components/alert/GrubToastMessage";
import { GrubPopupErrorHook } from "../../../hooks/index";
import store from "../../../store/store";

export const usePhoneSignUp = props => {
    // const { error } = GrubErrorHook();
    const { error } = GrubPopupErrorHook();

    const { addToast } = GrubToastMessage();
    const [buttonDisable, setButtonDisable] = useState(false);
    const [showVerification, setShowVerification] = useState(false);
    const countryCodes = Constants.COUNTRY_CODES;
    const [selectedCountryCode, setSelectedCountryCode] = useState(countryCodes[0]);
    const [loading, setLoading] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [phoneSignUpOpen, setPhoneSignUpOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const isSubmittingRef = useRef(false);
    const [phoneUpdate, setPhoneUpdate] = useState(false);
    const phoneRef = useRef();

    useEffect(() => {
        if (props.isOpen) {
            if(props.phoneUpdate){
                setPhoneUpdate(true);
            }
            setIsFocused(true);
            setTimeout(() => {
                phoneRef.current = true;
            }, 2000);
            if(props.phoneUp){
                changeToSignUpHandler();
            }
        }
    }, [props.isOpen]);

    const handleFocus = (event) => { event.target.scrollIntoView({ behavior: "smooth", block: "center" }); };

    const formatPhoneNumber = (value) => {
        const cleaned = value.replace(/\D/g, '');
        const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
        if (!match) return value;
        const [, first, second, third] = match;
        if (!second) return first;
        if (!third) return `${first}-${second}`;
        return `${first}-${second}-${third}`;
    };

    const handlePhoneChange = (e) => {
        const formatted = formatPhoneNumber(e.target.value);
        const rawValue = formatted.replace(/\D/g, ''); // Remove non-digits

        if (rawValue.length > 0) {
            const validValue = rawValue.replace(/^0+/, '');
            if (validValue.length > 0) {
                formik.setFieldValue('phone', validValue);
                e.target.value = formatPhoneNumber(validValue);
            } else {
                formik.setFieldValue('phone', '');
                e.target.value = '';
            }
        } else {
            formik.setFieldValue('phone', '');
            e.target.value = '';
        }
    };
    
    const formik = useFormik({
        initialValues: {
            phone: "",
        },
        validationSchema: Yup.object({
            phone: Yup.string()
                .required(Constants.USER_PHONE_NUMBER_REQUIRED)
                .matches(/^[0-9\b]+$/, Constants.USER_PHONE_NUMBER__NOT_VALID)
                .min(3, Constants.USER_PHONE_NUMBER_MUST_BE_3_DIGITS)
                .max(10, Constants.USER_PHONE_NUMBER_GREATER_THEN_10),
        }),
        onSubmit: values => {
            handleSubmit();
        }
    });

    const handleSubmit = async () => {
        isSubmittingRef.current = true;
        setLoading(true);
        const user = store.getState().user?.user;
        try {
            setLoading(true);
            setButtonDisable(true);
            sendOTP({
                phone_number: `${formik.values.phone}`,
                business_name: localStorage.getItem("business_name"),
                phone_update: props.phoneUpdate,
                user_id: props.phoneUpdate ? user?.id : null
            }).then(response => {
                if (
                    undefined !== response.data.flag &&
                    null !== response.data.flag &&
                    response.data.flag == true
                ) {
                    if(response?.data?.data?.otp_token){
                        localStorage.setItem('otp_token', response?.data?.data?.otp_token);
                    }
                    // addToast({
                    //     alertStatus: Constants.TOAST_TYPE_SUCESS,
                    //     alertTitle: 'Success',
                    //     alertDescription: response.data.message
                    // });
                    props.handleBackButton(false);
                    props.handlePhoneVerificationOpen(formik.values.phone,response.data.data.otp_code,response.data.data.purpose,props.phoneUpdate, false);
                    // props.onOTPSent(formik.values.phone);
                    setLoading(false);
                    setButtonDisable(false);
                    isSubmittingRef.current = false;
                }
            })
            .catch(err => {
                let actionData = err;
                // error({ actionData });
                let popupError = error({ actionData });
                if (popupError.error) {
                    setErrorMessage(popupError);
                    setTimeout(() => {
                        setErrorMessage({});
                    }, 5000);
                }
                isSubmittingRef.current = false;
                setLoading(false);
                setButtonDisable(false);
            });
        } catch (error) {
            let actionData = error;
            // error({ actionData });
            let popupError = error({ actionData });
            if (popupError.error) {
                setErrorMessage(popupError);
                setTimeout(() => {
                    setErrorMessage({});
                }, 5000);
            }
            setLoading(false);
            setButtonDisable(false);
            isSubmittingRef.current = false;
        }
    };

    const handleKeyDown = event => {
        if (
            event.key === "Enter" &&
            !buttonDisable &&
            formik.values.phone &&
            !formik.errors.phone
        ) {
            handleSubmit();
        }
    };

    const setCountryCodeHandler = (country) => {
        setSelectedCountryCode(country);
    };

    const changeToSignUpHandler = () => {
        if(phoneSignUpOpen){
            setPhoneSignUpOpen(false);
            formik.resetForm();
        }
        else{
            setPhoneSignUpOpen(true);
            formik.resetForm();
        }
    };

    return [
        handleKeyDown,
        formik,
        buttonDisable,
        handleSubmit,
        isSubmittingRef,
        // handleBackButton,
        showVerification,
        setShowVerification,
        countryCodes,
        selectedCountryCode,
        setCountryCodeHandler,
        loading,
        phoneSignUpOpen,
        handlePhoneChange,
        formatPhoneNumber,
        changeToSignUpHandler,
        isFocused,
        errorMessage,
        phoneRef,
        phoneUpdate,
        handleFocus
    ];
}; 